// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var PermissionTree$ReactHooksTemplate = require("./settings/permissionTree.res.js");

function initValue_0(param) {
  return false;
}

var initValue_1 = PermissionTree$ReactHooksTemplate.emptyPermission();

var initValue = [
  initValue_0,
  initValue_1
];

var authContext = React.createContext(initValue);

var make = authContext.Provider;

exports.initValue = initValue;
exports.authContext = authContext;
exports.make = make;
/* initValue Not a pure module */
